/** InsCoder WANG.J 2026-09-14 B + Metal Type pop-out interactions **/
(function () {
  'use strict';

  if (document.documentElement.hasAttribute('data-cust-metal-type-popout-ready')) return;
  document.documentElement.setAttribute('data-cust-metal-type-popout-ready', '');

  var mobileMedia = window.matchMedia('(max-width: 768px)');
  var activeDesktopOption = null;
  var activeMobileTrigger = null;

  function getRoot(element) {
    return element && element.closest('[data-cust-metal-type-popout]');
  }

  function getTrigger(option) {
    return option && option.querySelector('[data-cust-metal-type-trigger]');
  }

  function getMobile(trigger) {
    var controlsId = trigger && trigger.getAttribute('aria-controls');
    return controlsId ? document.getElementById(controlsId) : null;
  }

  function setTriggerExpanded(trigger, expanded) {
    if (trigger) {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }

  function hideDesktop() {
    if (!activeDesktopOption) return;

    var root = getRoot(activeDesktopOption);
    var tooltip = root && root.querySelector('[data-cust-metal-type-tooltip]');
    var trigger = getTrigger(activeDesktopOption);

    if (tooltip) tooltip.hidden = true;
    setTriggerExpanded(trigger, false);
    activeDesktopOption = null;
  }

  function showDesktop(option) {
    if (!option || mobileMedia.matches) return;

    hideDesktop();

    var root = getRoot(option);
    var tooltip = root && root.querySelector('[data-cust-metal-type-tooltip]');
    var message = tooltip && tooltip.querySelector('[data-cust-metal-type-tooltip-message]');
    var trigger = getTrigger(option);

    if (!root || !tooltip || !message || !trigger) return;

    message.textContent = option.getAttribute('data-cust-metal-type-message') || '';
    tooltip.hidden = false;

    var rootRect = root.getBoundingClientRect();
    var optionRect = option.getBoundingClientRect();
    var triggerRect = trigger.getBoundingClientRect();
    var tooltipRect = tooltip.getBoundingClientRect();
    var optionCenter = optionRect.left - rootRect.left + optionRect.width / 2;
    // The arrow points at the info icon of the hovered option, not the option centre.
    var triggerCenter = triggerRect.left - rootRect.left + triggerRect.width / 2;
    var maximumLeft = Math.max(0, rootRect.width - tooltipRect.width);
    var tooltipLeft = Math.min(Math.max(optionCenter - tooltipRect.width / 2, 0), maximumLeft);
    var arrowLeft = triggerCenter - tooltipLeft;

    tooltip.style.left = tooltipLeft + 'px';
    tooltip.style.top = optionRect.top - rootRect.top - tooltipRect.height - 12 + 'px';
    tooltip.style.setProperty('--cust-metal-type-arrow-left', arrowLeft + 'px');
    setTriggerExpanded(trigger, true);
    activeDesktopOption = option;
  }

  function hideMobile(returnFocus) {
    if (!activeMobileTrigger) return;

    var trigger = activeMobileTrigger;
    var mobile = getMobile(trigger);

    if (mobile) mobile.hidden = true;
    setTriggerExpanded(trigger, false);
    activeMobileTrigger = null;

    if (returnFocus) trigger.focus();
  }

  function showMobile(trigger) {
    if (!trigger || !mobileMedia.matches) return;

    if (activeMobileTrigger === trigger) {
      hideMobile(false);
      return;
    }

    hideMobile(false);

    var option = trigger.closest('[data-cust-metal-type-option]');
    var mobile = getMobile(trigger);
    var title = mobile && mobile.querySelector('[data-cust-metal-type-mobile-title]');
    var message = mobile && mobile.querySelector('[data-cust-metal-type-mobile-message]');

    if (!option || !mobile || !title || !message) return;

    title.textContent = option.getAttribute('data-cust-metal-type-title') || '';
    message.textContent = option.getAttribute('data-cust-metal-type-message') || '';

    // The pop-out is absolutely positioned, so it floats below its own option
    // without pushing the content below (offsetTop shares the pop-out's offsetParent).
    mobile.style.top = option.offsetTop + option.offsetHeight + 8 + 'px';
    mobile.hidden = false;

    var mobileRect = mobile.getBoundingClientRect();
    var triggerRect = trigger.getBoundingClientRect();
    var arrowLeft = triggerRect.left - mobileRect.left + triggerRect.width / 2;

    mobile.style.setProperty('--cust-metal-type-arrow-left', arrowLeft + 'px');
    setTriggerExpanded(trigger, true);
    activeMobileTrigger = trigger;
  }

  document.addEventListener('mouseover', function (event) {
    if (mobileMedia.matches) return;

    var option = event.target.closest('[data-cust-metal-type-option]');
    if (!option || option.contains(event.relatedTarget)) return;

    showDesktop(option);
  });

  document.addEventListener('mouseout', function (event) {
    if (mobileMedia.matches) return;

    var option = event.target.closest('[data-cust-metal-type-option]');
    if (!option || option.contains(event.relatedTarget)) return;

    var trigger = getTrigger(option);
    if (document.activeElement !== trigger) hideDesktop();
  });

  document.addEventListener('focusin', function (event) {
    var trigger = event.target.closest('[data-cust-metal-type-trigger]');
    if (trigger && !mobileMedia.matches) {
      showDesktop(trigger.closest('[data-cust-metal-type-option]'));
    }
  });

  document.addEventListener('focusout', function (event) {
    if (!mobileMedia.matches && event.target.matches('[data-cust-metal-type-trigger]')) {
      hideDesktop();
    }
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cust-metal-type-trigger]');

    if (trigger) {
      event.preventDefault();
      event.stopPropagation();

      if (mobileMedia.matches) {
        showMobile(trigger);
      } else {
        showDesktop(trigger.closest('[data-cust-metal-type-option]'));
      }

      return;
    }

    if (event.target.closest('[data-cust-metal-type-close]')) {
      event.preventDefault();
      hideMobile(true);
      return;
    }

    var label = event.target.closest('.cust-metal-type-popout__label');

    if (label && mobileMedia.matches) {
      var option = label.closest('[data-cust-metal-type-option]');
      var optionTrigger = getTrigger(option);

      window.setTimeout(function () {
        showMobile(optionTrigger);
      }, 0);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    if (activeMobileTrigger) {
      hideMobile(true);
    } else {
      hideDesktop();
    }
  });

  function handleBreakpointChange() {
    hideDesktop();
    hideMobile(false);
  }

  if (mobileMedia.addEventListener) {
    mobileMedia.addEventListener('change', handleBreakpointChange);
  } else {
    mobileMedia.addListener(handleBreakpointChange);
  }
})();
/** InsCoder WANG.J 2026-09-14 E + Metal Type pop-out interactions **/
